<bootstrap-popup [id]="id" [title]="'Enveloppe'" [displaySubject]="displaySubject" 
	[windowCloseButton]="true"  [modalSize]="'modal-lg'" >
	<div class="row panneaux">
		<pannel [title]="'Détails de l\'enveloppe'" [expandable]="true">
			<div class="mat-elevation-z8">
				<table mat-table matSort [dataSource]="envelopeDatasource">
				
					<ng-container matColumnDef="sentDateTime">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>Date d'envoi</th>
						<td mat-cell *matCellDef="let envelope"> {{ envelope.sentDateTime }} </td>
					</ng-container>
					
					<ng-container matColumnDef="status">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>Statut</th>
						<td mat-cell *matCellDef="let envelope"> {{ envelope.status === 'sent' ? 'En cours de signature' : 'Signée' }} </td>
					</ng-container>
				
					<ng-container matColumnDef="dateRelance">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>Date de relance</th>
						<td mat-cell *matCellDef="let envelope"> {{ envelope.dateRelance }} </td>
					</ng-container>
				
					<ng-container matColumnDef="dateFinalisation">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>Date de finalisation</th>
						<td mat-cell *matCellDef="let envelope"> {{ envelope.dateFinalisation }} </td>
					</ng-container>
				
					<ng-container matColumnDef="actions">
						<th mat-header-cell *matHeaderCellDef></th>
						<td mat-cell *matCellDef="let envelope" class="actions" >
							<a href="#" title="Télécharger le document à jour présent dans l'enveloppe" (click)="telecharger(envelope)" >
								<i class="fa-regular fa-file-pdf fa-lg"></i>
							</a>
							<a href="#" title="Relancer les signatures" (click)="relancer(envelope)" [ngClass]="{
								'text-success': envelope.isRetryable,
								'disabled' : !envelope.isRetryable
							}">
								<i class="fa fa-repeat fa-lg"></i>
							</a>
							<a href="#" title="Annuler l'enveloppe DocuSign" (click)="cancel(envelope)" class="text-danger">
								<i class="fa fa-ban fa-lg"></i>
							</a>
						</td>
					</ng-container>
				
					<tr mat-header-row *matHeaderRowDef="envelopeColumns"></tr>
					<tr mat-row *matRowDef="let row; columns: envelopeColumns"></tr>
				</table>
			</div>
		</pannel>
		
		<pannel [title]="'Signataires'" [expandable]="true">
		<div class="mat-elevation-z8">
			<table mat-table matSort [dataSource]="signatairesDatasource">
				<ng-container matColumnDef="nomPrenom">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>Nom Prénom</th>
					<td mat-cell *matCellDef="let signataire"> {{ signataire.nomPrenom }} </td>
				</ng-container>
			
				<ng-container matColumnDef="email">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>E-mail</th>
					<td mat-cell *matCellDef="let signataire"> {{ signataire.email }} </td>
				</ng-container>
			
				<ng-container matColumnDef="hasSigned">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>Statut</th>
					<td mat-cell *matCellDef="let signataire"> {{ signataire.hasSignedEnvelope ? 'Signé' : 'Non signé' }} </td>
				</ng-container>
			
				<ng-container matColumnDef="sentDateTime">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>Date de réception</th>
					<td mat-cell *matCellDef="let signataire"> {{ signataire.dateEnvoi }} </td>
				</ng-container>
			
				<ng-container matColumnDef="dateSignature">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>Date de signature</th>
					<td mat-cell *matCellDef="let signataire"> {{ signataire.dateSignature }} </td>
				</ng-container>
			
				<tr mat-header-row *matHeaderRowDef="signerColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: signerColumns"></tr>
			</table>
		</div>
		</pannel>
		
		<div class="col-md-12 text-center">
			<button class="btn btn-primary" style="margin-right: 10px" (click)="onCloseRequested()">
				Fermer
			</button>
		</div>
	</div>
</bootstrap-popup>